import { render, staticRenderFns } from "./DynamicEventForm.vue?vue&type=template&id=23daada6"
import script from "./DynamicEventForm.vue?vue&type=script&lang=js"
export * from "./DynamicEventForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicEventForm.vue?vue&type=style&index=0&id=23daada6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports